import React, { FunctionComponent, PropsWithChildren } from 'react';

import {
  default as MuiDialogTitle,
  DialogTitleProps,
} from '@mui/material/DialogTitle';

const DialogTitle: FunctionComponent<DialogTitleProps> = (
  props: PropsWithChildren<DialogTitleProps>
) => {
  return <MuiDialogTitle {...props}>{props.children}</MuiDialogTitle>;
};

export default DialogTitle;
